import { Injectable, inject } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { RedirectModalComponent } from "../signupRedirectModal/redirect-modal.component";

@Injectable({ providedIn: "root" })
export class SignUpRedirectModalService {
  private dialog = inject(MatDialog);

  private dialogRef!: MatDialogRef<RedirectModalComponent>;

  signupComplete(): void {
    this.dialog.closeAll();
    this.dialogRef = this.dialog.open(RedirectModalComponent, {
      data: "signupComplete",
      width: "395px",
      disableClose: true,
      panelClass: ["mat-typography", "onsip-dialog-universal-style"]
    });
  }

  redirectToApp(): void {
    this.dialog.closeAll();
    this.dialogRef = this.dialog.open(RedirectModalComponent, {
      data: "redirectToApp",
      width: "395px",
      disableClose: true,
      panelClass: ["mat-typography", "onsip-dialog-universal-style"]
    });
    setTimeout(() => (window.location.href = "https://app.onsip.com/app"), 3000);
  }

  loadingModal(data: "createAccount" | "createTopics"): void {
    this.dialog.closeAll();
    this.dialogRef = this.dialog.open(RedirectModalComponent, {
      data,
      width: "395px",
      disableClose: true,
      panelClass: ["mat-typography", "onsip-dialog-universal-style"]
    });
  }

  closeDialog(): void {
    if (this.dialogRef) this.dialogRef.close();
  }
}
